// extracted by mini-css-extract-plugin
export var quantityInput = "_gh-0";